import { CalendarOutlined, DollarCircleOutlined, FileExclamationOutlined } from '@ant-design/icons'

export const flags = [
  {
    text: 'Expiring',
    value: 'is-expiring',
    icon: CalendarOutlined,
    className: 'text-orange-500'
  },
  {
    text: 'Expired',
    value: 'is-expired',
    icon: CalendarOutlined,
    className: 'text-red-500'
  },
  {
    text: 'Balance Due',
    value: 'balance-due',
    icon: DollarCircleOutlined,
    className: 'text-blue-500'
  },
  {
    text: 'Credit Balance',
    value: 'credit-balance',
    icon: DollarCircleOutlined,
    className: 'text-green-500'
  },
  {
    text: 'Outstanding Balance',
    value: 'outstanding-balance',
    icon: DollarCircleOutlined,
    className: 'text-red-500'
  },
  {
    text: 'Has Open Invoices',
    value: 'has-open-invoices',
    icon: FileExclamationOutlined,
    className: 'text-blue-500'
  }
]

export const baseCellClassName = 'text-xs font-lato'
export const baseHeaderCellClassName = 'text-[0.675rem] uppercase font-lato !bg-transparent'
